export default function onBlurProp(action: () => any): {
   onBlur: React.FocusEventHandler<HTMLElement>
} {
   return {
      onBlur: () => {
         action()
      },
   }
}
